import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";

const InstallPWA = () => {
  const [isReady, setIsReady] = useState(Boolean(window.deferredPrompt));
  const [isInstalled, setIsInstalled] = useState(false);

  useEffect(() => {
    // 1. Check if already installed / running in standalone mode
    if (
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true
    ) {
      setIsInstalled(true);
      return;
    }

    if (window.deferredPrompt) {
      setIsReady(true);
    }

    // 2. React to beforeinstallprompt event
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      window.deferredPrompt = e;
      setIsReady(true);
    };

    const handlePromptReady = () => {
      setIsReady(true);
    };

    // 3. React to appinstalled event
    const handleAppInstalled = () => {
      setIsInstalled(true);
      setIsReady(false);
      window.deferredPrompt = null;
      Swal.fire({
        icon: "success",
        title: "App Installed!",
        text: "MT Products aapke device par safaltapoorvak install ho gaya hai.",
        timer: 2000,
        showConfirmButton: false,
      });
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("pwa-prompt-ready", handlePromptReady);
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("pwa-prompt-ready", handlePromptReady);
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  const handleInstall = async () => {
    const promptEvent = window.deferredPrompt;

    if (!promptEvent) {
      // Guide user on how to install directly from browser bar
      await Swal.fire({
        icon: "info",
        title: "Install MT App",
        html: `
          <div style="font-size: 14px; line-height: 1.6; text-align: left; color: #374151;">
            <p style="margin-bottom: 10px;">
              Aap is app ko apne system ya phone me directly install kar sakte hain:
            </p>
            <div style="background: #f3f4f6; padding: 10px 14px; border-radius: 8px; margin-bottom: 8px;">
              <strong>💻 Chrome / Edge (Laptop / Desktop):</strong><br/>
              Browser address bar ke right side me <strong>Install Icon (⊕ ya ⬇️)</strong> par click karein.
            </div>
            <div style="background: #f3f4f6; padding: 10px 14px; border-radius: 8px; margin-bottom: 8px;">
              <strong>📱 Android (Chrome):</strong><br/>
              Right top (⋮) menu par tap karein aur <strong>"Install app" / "Add to Home screen"</strong> select karein.
            </div>
            <div style="background: #f3f4f6; padding: 10px 14px; border-radius: 8px;">
              <strong>🍏 iPhone / iPad (Safari):</strong><br/>
              Share button (⎋) par tap karein aur <strong>"Add to Home Screen"</strong> choose karein.
            </div>
          </div>
        `,
        confirmButtonText: "Theek Hai",
        confirmButtonColor: "#4f46e5",
      });
      return;
    }

    // Trigger standard browser native installation prompt
    try {
      promptEvent.prompt();
      const choice = await promptEvent.userChoice;
      window.deferredPrompt = null;
      setIsReady(false);

      if (choice.outcome === "accepted") {
        Swal.fire({
          icon: "success",
          title: "Installing...",
          text: "App installation shuru ho gaya hai.",
          timer: 1800,
          showConfirmButton: false,
        });
      }
    } catch (err) {
      console.warn("PWA install error:", err);
    }
  };

  if (isInstalled) return null;

  return (
    <button
      onClick={handleInstall}
      type="button"
      style={{
        width: "100%",
        padding: "10px 16px",
        background: isReady ? "rgba(16, 185, 129, 0.08)" : "transparent",
        border: "none",
        textAlign: "left",
        display: "flex",
        alignItems: "center",
        gap: "10px",
        cursor: "pointer",
        fontSize: "13px",
        fontWeight: "600",
        color: isReady ? "#059669" : "#4b5563",
        borderBottom: "1px solid #e5e7eb",
        transition: "all 0.15s ease",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.background = isReady ? "rgba(16, 185, 129, 0.15)" : "#f3f4f6")}
      onMouseLeave={(e) => (e.currentTarget.style.background = isReady ? "rgba(16, 185, 129, 0.08)" : "transparent")}
      title="Install as Progressive Web App"
    >
      <span style={{ fontSize: "16px" }}>📲</span>
      <span>{isReady ? "Install App (Ready)" : "Install App"}</span>
      {isReady && (
        <span
          style={{
            marginLeft: "auto",
            fontSize: "10px",
            background: "#10b981",
            color: "#ffffff",
            padding: "2px 7px",
            borderRadius: "10px",
            fontWeight: "700",
          }}
        >
          READY
        </span>
      )}
    </button>
  );
};

export default InstallPWA;
